import React from "react";
import {
    Router,
    Switch,
    Route,
} from 'react-router-dom';
import ReviewPage from "../../pages/review_screen";
import ParseNewFilms from "../../pages/parse_new_films";
import NavigationService from "./service";

export default function RootNavigator() {
    return (
        <Router history={NavigationService.instance.history}>
            <p onClick={() => {
                NavigationService.instance.navigateReviewPending()
            }
            }>ReviewPending</p>
            <p onClick={() => {
                NavigationService.instance.navigateReviewDuplicates()
            }
            }>ReviewDuplicates</p>
            <p onClick={() => {
                NavigationService.instance.navigateUploadPending()
            }
            }>UploadPending</p>
            <Switch>
                <Route exact path="/" component={ReviewPage}/>
                <Route path="/review/:mode" component={ReviewPage}/>
                <Route path="/upload_pending_films" component={ParseNewFilms}/>
            </Switch>
        </Router>
);
}
